class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.delayTimeout = 1000;
    this.scrollTimeout = null;
  }

  connectedCallback() {
    this.button = this.querySelector("button");
    const delayAttr = this.getAttribute("data-delay");
    this.delayTimeout = delayAttr ? parseInt(delayAttr, 10) : 1000;

    if (this.button) {
      this.button.addEventListener("click", this.scrollTotop.bind(this));

      window.addEventListener("scroll", () => {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
          if (window.scrollY > 300) {
            this.setVisible();
          } else {
            this.setInvisible();
          }
          this.scrollTimeout = null;
        }, this.delayTimeout);
      });
    }
  }

  scrollTotop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  setInvisible() {
    this.classList.remove("visible");
  }

  setVisible() {
    this.classList.add("visible");
  }
}

if (!customElements.get("scroll-to-top-button-container")) {
  customElements.define("scroll-to-top-button-container", ScrollToTopButton);
}
